'use client';

import RealTimeMessages from '../../real-time-messages/nextjs/RealTimeMessages.js';
import type { ShowDialogFn } from '../../real-time-messages/nextjs/types.js';
import SilentErrorBoundary from './components/SilentErrorBoundary.js';
import { isGamingCareTurDisabled } from './config.js';

type GamingCareTurClientProps = {
  showDialog?: ShowDialogFn;
};

export default function GamingCareTurClient({ showDialog }: GamingCareTurClientProps): React.ReactNode {
  if (isGamingCareTurDisabled()) {
    return null;
  }

  return <SilentErrorBoundary>{showDialog && <RealTimeMessages showDialog={showDialog} />}</SilentErrorBoundary>;
}
